var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSms = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#454545",
  d: "M14 .5H2C1.175.5.507 1.175.507 2L.5 15.5l3-3H14c.825 0 1.5-.675 1.5-1.5V2c0-.825-.675-1.5-1.5-1.5Zm-2.25 9h-7.5a.752.752 0 0 1-.75-.75c0-.412.337-.75.75-.75h7.5c.412 0 .75.338.75.75s-.338.75-.75.75Zm0-2.25h-7.5a.752.752 0 0 1-.75-.75c0-.412.337-.75.75-.75h7.5c.412 0 .75.338.75.75s-.338.75-.75.75Zm0-2.25h-7.5a.752.752 0 0 1-.75-.75c0-.413.337-.75.75-.75h7.5c.412 0 .75.337.75.75 0 .412-.338.75-.75.75Z"
})));
export default SvgSms;